import React from 'react';
import { Button, Typography, TextField } from '@material-ui/core';
import { Formik } from 'formik';
import { ButtonFlex, FormRow, StyledForm } from '../../styles/styles';

const NameModal = ({ handleClose, name, description, updateTemplate }) => {
  return (
    <div style={{ minWidth: 300, paddingTop: '15px' }}>
      <Typography variant="h4" gutterBottom>
        Edit Template Name and Description
      </Typography>
      <Formik
        initialValues={{
          name,
          description,
        }}
        onSubmit={async values => {
          updateTemplate(values.name, values.description);
          handleClose();
        }}
        render={formikProps => {
          const {
            handleSubmit,
            isSubmitting,
            isValid,
            dirty,
            handleChange,
            handleBlur,
            values,
          } = formikProps;

          return (
            <StyledForm onSubmit={handleSubmit}>
              <FormRow>
                <TextField
                  label="Template Name"
                  name="name"
                  value={values.name}
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  fullWidth
                />
              </FormRow>
              <FormRow>
                <TextField
                  label="Template Description"
                  name="description"
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                  variant="outlined"
                  fullWidth
                />
              </FormRow>

              <ButtonFlex>
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  size="large"
                  disabled={!dirty || isSubmitting}
                  style={{
                    margin: '5px',
                  }}
                >
                  Submit
                </Button>
              </ButtonFlex>
            </StyledForm>
          );
        }}
      />
    </div>
  );
};

export default NameModal;
